module.exports = __webpack_public_path__ + "static/media/kcc-short-introduction-en-new.59be2280.mp4";